import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { clamp, tabIndexHTML } from '@helpers/utils';
import { useAutoplay } from '@hooks/useAutoplay';
import Dots from '@stories/Components/Misc/Carousels/Carousel/Dots/Dots';
import * as React from 'react';
import S from './AnnouncementBar.styles';
const AnnouncementBar = (props) => {
    const { activeIndex, setActiveIndex, setPaused } = useAutoplay({
        enabled: true,
        duration: props.duration ?? 5000,
        items: props.items ?? [],
    });
    return (React.createElement(S.Container, null, props.items && (React.createElement(React.Fragment, null,
        React.createElement(S.AnnouncementControls, null,
            React.createElement(S.AnnouncementButton, { onClick: () => {
                    setPaused(true);
                    if (activeIndex === 0) {
                        return setActiveIndex((props.items?.length ?? 0) - 1);
                    }
                    setActiveIndex(clamp(activeIndex - 1, (props.items?.length ?? 0) - 1));
                }, "aria-label": props.translations?.['global.announcements.previous'] }, getSystemIcon(SystemIcon.ChevronDown)),
            React.createElement(S.AnnouncementCount, { style: {
                    '--width': props.items.length > 10 ? `${6}ch` : undefined,
                } },
                activeIndex + 1,
                " / ",
                props.items.length),
            React.createElement(S.AnnouncementButton, { onClick: () => {
                    setPaused(true);
                    if (activeIndex === (props.items?.length ?? 0) - 1) {
                        return setActiveIndex(0);
                    }
                    setActiveIndex(clamp(activeIndex + 1, (props.items?.length ?? 0) - 1));
                }, "aria-label": props.translations?.['global.announcements.next'] }, getSystemIcon(SystemIcon.ChevronDown)),
            React.createElement(Dots, { activeIndex: activeIndex, itemCount: props.items.length })),
        React.createElement(S.AnnouncementTrack, { style: {
                '--speed': `${props.speed ?? props.items.length * 8}s`,
            } },
            props.items.map((item, i) => (React.createElement(S.AnnouncementItem, { key: item.id, "data-type": item.type, dangerouslySetInnerHTML: { __html: tabIndexHTML(item.text, activeIndex === i) }, "data-active": activeIndex === i }))),
            props.items.map((item) => (React.createElement(S.AnnouncementItem, { key: `${item.id}-duplicate`, "data-type": item.type, dangerouslySetInnerHTML: { __html: tabIndexHTML(item.text, false) }, "data-duplicate": true }))))))));
};
export default AnnouncementBar;
